module.exports = __webpack_public_path__ + "img/271202930.275175d5.jpg";